module.exports = __webpack_public_path__ + "static/media/WOODCREEK RULES AND REGULATION2018-2019.524fbbc8.docx";